/**
* @name: user-panel-body
* @author: weiyong
* @date: 2023-02-21 17:30
* @description：user-panel-body
* @update: 2023-02-21 17:30
*/
<template>
  <div class="user-panel-body" style="height: calc(100% - 46px);">
    <div class="section-member-fixed">
      <a href="javascript:void(0)"
         @click="searchByPinYin(item)"
         :class="item===curSelPinYin?'active':'notActive'"
         :key="index"
         v-for="(item,index) in pinyins">{{ item }}</a>
    </div>

    <div class="user-item-record-panel" style="padding-top: 32px;">
      <div class="user-item-record" :key="index" v-for="(item,index) in searchUserList">
        <user-show-item
          @selItemRecord="selItemRecord"
          :remark="getRemark(item)"
                        :icon="item.avatar"
                        :item="item"
                        :hasCheck="true"
                        :value="item.id"
                        :label="item.realName"/>
      </div>
    </div>

    <div class="pagination-box">
      <a-pagination v-bind="paginationProps" />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import { PaginationProps } from 'ant-design-vue'

export default defineComponent({
  components: {},
  name: "user-panel-body",
});
</script>

<script lang="ts" setup>
import { computed, defineEmits, defineExpose, toRefs } from 'vue'
import {Pagination as APagination} from 'ant-design-vue';
import UserShowItem from "../components/user-show-item.vue";
import {QueryUserByPinyin} from "../servers/userSelServer";
import GoingUtils from "@/utils/goingUtils";
import {afterLoadUser, hasSelRecord} from "../utils";

const searchUserList: any = ref([]);

const curSelPinYin=ref('全部');
const pinyins=[
  '全部','A','B','C','D','E','F','G','H','I','K','L','M','N','O','P','Q','R','S','T','X','Y','Z'
];

const props=defineProps({
  roleName:{},
  alreadySelUsers:{}
});
const {alreadySelUsers,roleName}:any=toRefs(props);

const current = ref(1)
const size = ref(10)
const total = ref(0)

QueryUserByPinyin(unref(''), (res) => {
  searchUserList.value = [];
  GoingUtils.closeLoading();
  if (res && res.records) {
    afterLoadUser(res,alreadySelUsers,searchUserList);
    total.value = res.total;
  }
},true,unref(roleName), {
  current: unref(current),
  size: unref(size)
});

/**
 * 根据拼音进行查询
 */
const searchByPinYin=function (item){
  curSelPinYin.value=item;
  let queryStr=item;
  if(item==='全部'){
    queryStr='';
  }

  current.value = 1

  QueryUserByPinyin(unref(queryStr), (res) => {
    searchUserList.value = [];
    GoingUtils.closeLoading();
    if (res && res.records) {
      afterLoadUser(res,alreadySelUsers,searchUserList);
      total.value = res.total;
    }
  },true,unref(roleName), {
    current: unref(current),
    size: unref(size)
  });
}

const emits=defineEmits(['selItemRecord']);
/**
 * 选择记录
 */
const selItemRecord=function ({item}){
  emits('selItemRecord',{item});
}

const flushUserList=function ({key}){
  current.value = 1

  //根据拼音进行查询
  QueryUserByPinyin('', (res) => {
    searchUserList.value = [];
    GoingUtils.closeLoading();
    if (res && res.records) {
      afterLoadUser(res,alreadySelUsers,searchUserList);
      total.value = res.total;
    }
  },true,unref(roleName),{
    tenantId:key,
    current: unref(current),
    size: unref(size)
  });
}
defineExpose({flushUserList});

const paginationProps = computed<PaginationProps>(() => {
  return {
    current: unref(current),
    pageSize: unref(size),
    total: unref(total),
    size: 'small',
    onChange: (page, pageSize) => {
      current.value = page;
      size.value = pageSize;

      let queryStr=unref(curSelPinYin);
      if(unref(curSelPinYin)==='全部'){
        queryStr='';
      }

      QueryUserByPinyin(unref(queryStr), (res) => {
        searchUserList.value = [];
        GoingUtils.closeLoading();
        if (res && res.records) {
          afterLoadUser(res,alreadySelUsers,searchUserList);
          total.value = res.total;
        }
      },true, undefined, {
        current: unref(current),
        size: unref(size)
      });
    }
  }
})

function getRemark (item) {
  const {
    tenantName,
    deptName,
    roleName
  } = item

  let str = [tenantName, deptName, roleName].filter(val => !!val).join('-')

  if (!str?.length) {
    str = '-'
  }

  return str
}
</script>

<style type="text/css" lang="less">
.user-panel-body {
  height: calc(100% - 34px);
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .user-item-record-panel{
    padding-top: 32px;
    flex: 1 1 auto;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .pagination-box {
    padding: 10px;
    text-align: right;
  }

  .section-member-fixed {
    position: absolute;
    color: #666;
    background-color: #f7f7f7;
    z-index: 999;
    top: 2px;
    height: 30px;
    line-height: 30px;
    left: 2px;
    right: 11px;
    font-size: 12px;
    padding: 0 6px;
    a {
      color: #666;
      margin: 0 5px;
    }
    .active{
      color:#ed3f13;;
    }
  }
}
</style>
